"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tag = void 0;
var tslib_1 = require("tslib");
var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");
var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");
var ui_icon_1 = require("@hopin-team/ui-icon");
var react_1 = tslib_1.__importDefault(require("react"));
var root_1 = require("./styled/root");
var Tag = function (_a) {
    var icon = _a.icon, label = _a.label, _b = _a.isPressed, isPressed = _b === void 0 ? false : _b, _c = _a.size, size = _c === void 0 ? 'tiny' : _c, onClick = _a.onClick, className = _a.className, __UIScope = _a.__UIScope, rest = tslib_1.__rest(_a, ["icon", "label", "isPressed", "size", "onClick", "className", "__UIScope"]);
    var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
        block: Tag.name,
        className: className,
        __UIScope: __UIScope,
    }).rootClasses;
    return (react_1.default.createElement(root_1.Root, tslib_1.__assign({ className: rootClasses, "aria-pressed": isPressed, onClick: onClick, size: size }, rest),
        icon && (react_1.default.createElement(ui_icon_1.Icon, { name: icon, title: "".concat(label, " icon"), focusable: "false", "aria-hidden": "true", isParentColor: true, mr: 1 })),
        label));
};
var TagWithSpace = (0, ui_helper_with_space_1.withSpace)(Tag);
exports.Tag = TagWithSpace;
//# sourceMappingURL=tag.js.map